import styled from "styled-components/macro";

export const ReminderButtonContent = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  gap: 6px;
  color: var(--fnBlue);
`;
